import Glider from 'glider-js'

export default class NewsSlider {

    constructor($view) {
        this.$view = $view;
        this.$slider = this.$view.find('.js-slides');
        this.glider = null;

        this.sliderEnabled = false;

        this.bind();
    }

    bind() {

        this.init();

        $(window).on('resize', (e) => {
            this.init();
        });

    }

    init() {

        if ($(window).width() < 768 && this.sliderEnabled === false) {

            this.glider = new Glider(this.$slider[0], {
                draggable: true,
                scrollLock: true,
                slidesToShow: 1.5
            });
            this.glider.refresh();

            this.sliderEnabled = true;

        } else if ($(window).width() >= 768 && this.sliderEnabled === true) {

            this.glider.destroy();
            this.sliderEnabled = false;

        }

    }

}